import { render, staticRenderFns } from "./AnswerRatingStart.vue?vue&type=template&id=f18515e4"
import script from "./AnswerRatingStart.vue?vue&type=script&lang=js"
export * from "./AnswerRatingStart.vue?vue&type=script&lang=js"
import style0 from "./AnswerRatingStart.vue?vue&type=style&index=0&id=f18515e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports